import { Stack } from "@zenchef/styled-system/jsx";
import { FC } from "react";
import {
  ToastActionTrigger,
  ToastDescription,
  ToastIcon,
  ToastProps,
  ToastRoot,
  ToastTitle,
} from "./toast-parts";
import withTestId from "../../utils/withTestId";

interface Props {
  toast: ToastProps;
}

const Toast: FC<Props> = ({ toast }) => {
  return (
    <ToastRoot function={toast.type}>
      {toast.meta?.icon && <ToastIcon name={toast.meta.icon} />}
      <Stack gap="1" flex="1">
        {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
        {toast.description && (
          <ToastDescription>{toast.description}</ToastDescription>
        )}
      </Stack>
      {toast.action && (
        // Error hidden because the type is come from the @zag-js/toast library, but this one is not installed
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        <ToastActionTrigger>{toast.action.label}</ToastActionTrigger>
      )}
    </ToastRoot>
  );
};

export default withTestId("toast")(Toast);
